/**
 *  AgContext.ts
 *
 *  @copyright 2023 Stride EdVentures
 *
 */
import { createContext } from 'react'
import { Settings } from 'src/services/models'

export const SeasonContext = createContext({
  // user: null as unknown as User,
  // setUser: (u: User) => {},
  season: null as unknown as number,
  setSeason: (u: number) => { }
})

export const SettingsContext = createContext({
  // user: null as unknown as User,
  // setUser: (u: User) => {},
  settings: undefined as Settings | undefined,
  setSettings: (u: Settings) => { }
})
